import getData from "@/__main__/get-data.mjs";
import type { Seasons } from "@/game-eft/models/graphql.mjs";
import { SeasonsValidate } from "@/game-eft/models/graphql.mjs";
import * as API from "@/game-eft/utils/api.mjs";

export async function fetchSeasons(): Promise<Seasons> {
  const seasons = await getData(API.getSeasons(), SeasonsValidate, [
    "eft",
    "seasons",
  ]);
  return seasons;
}
